export default __webpack_public_path__ + "static/media/bu-ani.249127e9.png";